<app-card-widget title="Notifications" *ngIf="invoice$ | async">

  <form [formGroup]="form" id="notification-form" (ngSubmit)="save()" *ngIf="usersMap$ | async as usersMap" novalidate>

    <div class="card-section-container">

      <div class="card-section">

        <mat-nav-list>
          <mat-list-item *ngFor="let item of notificationLogs$ | async" (click)="itemClicked(item)" [class.mat-elevation-z2]="item === selectedItem">
            <mat-icon matListIcon>notifications</mat-icon>
            <h3 matLine> {{item.getLabel()}} </h3>
            <span matLine>{{usersMap.get(item.userId)?.name}}</span>
            <div class="list-item-timestamp">{{item.changed | date:'shortDate'}}</div>
          </mat-list-item>
        </mat-nav-list>

      </div>
      <div class="card-section" *ngIf="selectedItem || added">

        <app-text label="Created" *ngIf="!added">{{selectedItem.getLabel()}}</app-text>

        <mat-form-field *ngIf="added">
          <mat-select placeholder="Notification" formControlName="notification">
            <mat-option *ngFor="let choice of notificationChoices" [value]="choice.value">
              {{choice.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="User" *ngIf="!added">{{usersMap.get(selectedItem.userId)?.name}}</app-text>

        <app-text label="Created" *ngIf="!added">{{selectedItem.changed | date:'shortDate'}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput [matDatepicker]="changedPicker" placeholder="Changed" formControlName="changed" />
          <mat-datepicker-toggle matSuffix [for]="changedPicker"></mat-datepicker-toggle>
          <mat-datepicker #changedPicker></mat-datepicker>
        </mat-form-field>

      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!added && !added" [disabled]="locked" (click)="add()">Add</button>
    <button type="submit" mat-button *ngIf="added" [disabled]="!form.valid || saving" form="notification-form">Save</button>
    <button type="reset" mat-button *ngIf="added" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>


